import React from 'react';

import { ProgressIndicator } from './ProgressIndicator';

interface StepContainerProps {
  currentStep: number;
  totalSteps: number;
  children: React.ReactNode;
}

export const StepContainer: React.FC<StepContainerProps> = ({
  currentStep,
  totalSteps,
  children,
}) => {
  return (
    <>
      <ProgressIndicator currentStep={currentStep} totalSteps={totalSteps} />
      <div className="rounded bg-white p-8 shadow-[0_0_3px_3px_rgba(0,0,0,0.03)] max-sm:p-6 md:p-8">
        {children}
      </div>
    </>
  );
};
